var map = {
  "./assets/favicons-prodaus1/android-chrome-192x192.png": "231141",
  "./assets/favicons-prodaus1/android-chrome-512x512.png": "592885",
  "./assets/favicons-prodaus1/apple-touch-icon.png": "7850",
  "./assets/favicons-prodaus1/browserconfig.xml": "681548",
  "./assets/favicons-prodaus1/favicon-16x16.png": "824901",
  "./assets/favicons-prodaus1/favicon-32x32.png": "175029",
  "./assets/favicons-prodaus1/favicon-alert-16x16.png": "46276",
  "./assets/favicons-prodaus1/favicon-alert-32x32.png": "856192",
  "./assets/favicons-prodaus1/favicon-alert.ico": "863167",
  "./assets/favicons-prodaus1/favicon.ico": "485942",
  "./assets/favicons-prodaus1/mstile-150x150.png": "835613",
  "./assets/favicons-prodaus1/site.webmanifest": "549659",
  "./assets/favicons-prodaus1/upc-favicon.ico": "258247"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 237076;
